import { render, staticRenderFns } from "./OrgHomeMarketing.vue?vue&type=template&id=83ecd84a&scoped=true&"
import script from "./OrgHomeMarketing.vue?vue&type=script&lang=js&"
export * from "./OrgHomeMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ecd84a",
  null
  
)

export default component.exports